// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ele-form-image{line-height:1em}.ele-form-image .el-image{margin-right:10px;margin-bottom:10px;border-radius:5px}", ""]);
// Exports
module.exports = exports;
